import { render, staticRenderFns } from "./ProfileList.vue?vue&type=template&id=2652d538&scoped=true&"
import script from "./ProfileList.vue?vue&type=script&lang=js&"
export * from "./ProfileList.vue?vue&type=script&lang=js&"
import style0 from "./ProfileList.vue?vue&type=style&index=0&id=2652d538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652d538",
  null
  
)

export default component.exports